<template>
<div>
  <div class="container-fluid yellow-letter">
    <div class="container align-middle">
      <div class="row">
        <div class="col-12">
          <div class="breadcrumbs">
            <a href="/">Главная</a> / <a href="https://poliglotiki.com/home-teacher/onlineteacher">OnlineTeacher</a> / Групповые онлайн занятия по английскому языку
          </div>

          <h1 class="desktop-vers">Английский <span class="yell-green">онлайн в группе</span></h1>
          <h1 class="mobile-vers">Английский<br> <span class="yell-green">онлайн в группе</span></h1>
          <img src="~@/assets/hometeacher/images/childs-2.png" alt="Групповые онлайн занятия по английскому языку" class="childs">

            <h3>для современных детей от 12 месяцев до 12 лет</h3>

            <p>Обучение детей в группе онлайн через игру и увлекательные задания <span class="strong-black">с полным погружением</span> в изучаемую языковую среду.</p>

            <p>Педагог говорит <span class="strong-black">только на иностранном</span>, использует невербальное общение, мимику, жесты, наглядные материал, что способствует <span class="strong-black">легкому восприятию и быстрому усвоению информации</span>.</p>

            <div class="knpk"><a href="https://poliglotiki.com/home-teacher/schedule">Попробовать бесплатно</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid yellow-wave"></div>
  <div class="container-fluid small-clouds no-shadow">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8">
          <h2 class="iba desktop-vers">Учитесь <span class="yegr">в любом месте</span></h2>
          <h2 class="iba mobile-vers">Учитесь<br> <span class="yegr">в любом месте</span></h2>
          <img src="~@/assets/hometeacher/images/twokinds.png" alt="Групповые онлайн занятия по английскому языку" class="twokinds mobile-vers">
          <div class="chek"></div><p><span class="strong-black">Не нужно тратить время</span> на дорогу и сборы.</p>
          <div class="chek"></div><p>Можно заниматься <span class="strong-black">в любом уголке мира</span>, в любом городе и стране.</p>
          <div class="chek"></div><p><span class="strong-black">Мы обучаем через Интернет</span>, подключайтесь к группе из дома, в машине, на даче, на отдыхе за границей или у бабушки в деревне.</p>
          <div class="chek"></div><p style="max-width: 585px;">Нужен <span class="strong-black">обычный смартфон или планшет</span> с устойчивой связью от 1 Мбит/сек.</p>
          <div class="chek"></div><p style="max-width: 610px;">Осенью и весной, летом и зимой &ndash; выбирайте <span class="strong-black">удобное время уроков</span> из предложенного расписания группы. Режим и график занятий для ребенка родители определяют сами.
        </p>
        </div>

        <div class="col-12 col-sm-4">
          <img src="~@/assets/hometeacher/images/twokinds.png" alt="Групповые онлайн занятия по английскому языку" class="twokinds desktop-vers">
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid no-shadow par fr-page">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-4">
          <img src="~@/assets/hometeacher/images/birdskids.jpg" alt="Групповые онлайн занятия по английскому языку" class="birdskids desktop-vers">
        </div>
        <div class="col-12 col-sm-8 pdlft80px">
          <h2 class="iba desktop-vers"><span class="gryelgrn">Групповые</span> занятия</h2>
          <h2 class="iba mobile-vers"><span class="gryelgrn">Групповые</span><br> занятия</h2>
          <img src="~@/assets/hometeacher/images/birdskids.jpg" alt="Групповые онлайн занятия по английскому языку" class="birdskids mobile-vers">
          <div class="chek"></div><p>Групповые онлайн-занятия мы проводим <span class="strong-black">с 4-8 детьми</span>, близкими по возрасту и уровню подготовки.</p>
          <div class="chek"></div><p>Максимальное количество учеников — <span class="strong-black">10 человек</span>.</p>
          <p class="leftp">Изучение английского онлайн в мини-группе позволяет детям <span class="strong-black">преодолеть стеснение</span>, получать удовольствие от общения со сверстниками и совершенствовать <span class="strong-black">коммуникативный навык</span>. </p>
          <p class="leftp desktop-vers"><span class="yelspan">Живое занятие сразу с несколькими детьми создает <span class="strong-black">полное</span></span><br>
            <span class="yelspan"><span class="strong-black">ощущение присутствия</span>, как будто вы находитесь на очном уроке. </span></p>
          <div class="yellfon mobile-vers">
            Живое занятие сразу с несколькими детьми создает <span class="strong-black">полное ощущение присутствия</span>, как будто вы находитесь на очном уроке.
          </div>
          <p class="leftp">Благодаря небольшому размеру группы, педагог <span class="strong-black">вовлекает в занятие</span> абсолютно всех учеников и может уделить <span class="strong-black">внимание каждому</span>.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid small-strelki no-shadow pdtop50px">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8">
          <h2 class="iba">Учитесь <span class="igraya">играя</span></h2>
          <!--<h2 class="iba mobile-vers">Учитесь<br> <span class="igraya">играя</span></h2> -->
          <img src="~@/assets/hometeacher/images/notekids.png" alt="Групповые онлайн занятия по английскому языку" class="twokinds mobile-vers">
          <p class="leftp">Современные технологии повсюду. <span class="strong-black">Детям интересны технические новинки, смартфоны и компьютеры с рождения.</span></p>
          <p class="leftp mrgtopbtn desktop-vers"><span class="yelspan"><span class="strong-black">Превратите компьютер из простой «игрушки» в средство языкового</span></span><br>
            <span class="yelspan"><span class="strong-black">развития и онлайн общения в группе.</span></span></p>
          <div class="yellfon mobile-vers">
            <span class="strong-black">Превратите компьютер из простой «игрушки» в средство языкового развития и онлайн общения в группе.</span>
          </div>
          <p class="leftp" style="margin-bottom: 30px;"><span class="strong-black">«Полиглотики» обучают малышей и подростков более 15 лет</span>, и мы знаем, что детям трудно долго сидеть на месте. Поэтому на онлайн-занятиях мы используем:</p>

          <div class="chek"></div><p><span class="strong-black">Захватывающие внимание</span> мультфильмы и яркие иллюстрации</p>
          <div class="chek"></div><p style="max-width: 635px;"><span class="strong-black">Игры, раскраски и задания на мониторе</span>, которые дети выполняют вместе с педагогом</p>
          <div class="chek"></div><p><span class="strong-black">Мини-зарядка</span> на иностранном языке</p>
          <div class="chek"></div><p style="max-width: 635px;"><span class="strong-black">Детские песенки</span> в формате караоке, которые <span class="strong-black">быстро запоминаются</span></p>
          <div class="chek"></div><p style="max-width: 615px;">Интерактивные озвученные <span class="strong-black">тренажеры, простые тесты, загадки</span></p>
        </div>

        <div class="col-12 col-sm-4">
          <img src="~@/assets/hometeacher/images/notekids.png" alt="Групповые онлайн занятия по английскому языку" class="twokinds desktop-vers">
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <img src="~@/assets/hometeacher/images/clock.png" class="clock mobile-vers">
          <p class="px20 leftp">Продолжительность одного онлайн-занятия в группе — <span class="yelspan"><span class="strong-black">45-60 минут.</span></span></p>

          <div class="shag"><span class="strong-black">Сделайте шаг в будущее</span> &ndash; интерактивные технологии образовательной платформы OnlineTeacher подарят <span class="strong-black">радость и знания вашим детям</span>.</div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid bigwavetop desktop-vers"></div>
  <div class="container-fluid listochki">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-10">
          <img src="~@/assets/hometeacher/images/raketa2.png" alt="Групповые онлайн занятия по английскому языку" class="raketa desktop-vers">
          <h2 class="iba">Иностранные языки детям <span class="dostavka">с доставкой</span></h2>
          <img src="~@/assets/hometeacher/images/raketa2.png" alt="Групповые онлайн занятия по английскому языку" class="raketa mobile-vers">

          <p class="leftp" style="font-size: 25px; max-width: 415px; margin-bottom: 40px;">Мы доставляем иностранный язык <span class="strong-black">прямо к вам домой!</span></p>

          <div class="chek"></div><p>Ребенок находится <span class="strong-black">в привычной обстановке</span>.</p>
          <div class="chek"></div><p>Занимается <span class="strong-black">в свободное</span> от учебы, кружков и секций <span class="strong-black">время</span>.</p>
          <div class="chek"></div><p style="max-width: 600px;"><span class="strong-black">Без стресса и стеснительности</span> в онлайн-группах дети <span class="strong-black">легко преодолевают языковой барьер</span> и начинают общаться на иностранном языке.</p>

          <p class="leftp desktop-vers" style="font-size: 25px; max-width: 600px; margin-top: 40px;">Наша цель &ndash; стимулировать   <span class="yelspan"><span class="strong-black">искренний интерес</span></span>
            и азарт детей   <span class="yelspan"><span class="strong-black">к изучению языка.</span></span></p>

          <p class="leftp mobile-vers" style="font-size: 25px; max-width: 600px; margin-top: 40px;">Наша цель &ndash; стимулировать<br>   <span class="yelspan"><span class="strong-black">искренний интерес</span></span><br>
            и азарт детей<br>   <span class="yelspan"><span class="strong-black">к изучению языка.</span></span></p>
        </div>

        <div class="col-12 col-sm-2">

        </div>
      </div>

    </div>
  </div>
  <div class="container-fluid bigwavebottom desktop-vers"></div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid fon-krugi">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-7">
          <h2 class="iba"><span class="uvlek">Увлекательные</span> программы</h2>
          <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img src="~@/assets/hometeacher/images/programmki-mob.jpg" alt="Групповые онлайн занятия по английскому языку" class="programmki"></div>
          <p class="px20"><span class="strong-black">Собственные авторские программы</span> «Полиглотиков», качественно адаптированные под онлайн-формат и <span class="strong-black">дополненные интерактивами, материалами для скачивания и тренажерами.</span></p>
          <p class="px20">Наши онлайн-программы обучения построены таким образом, что позволяют <span class="strong-black">новичку присоединиться к занятиям с любого этапа</span> (и позже пройти неохваченные темы). </p>
          <p class="px20"><span class="strong-black">Занятия понятны</span>, наполнены игровыми элементами и <span class="strong-black">интересны детям.</span></p>

          <p class="razvsov desktop-vers">Программы направлены на  <span class="yelspan"><span class="strong-black">развитие и совершенствование</span></span>  навыков говорения, аудирования, чтения, письма, проработку лексики и грамматики.</p>

          <p class="razvsov mobile-vers">Программы направлены на  <span class="yelspan"><span class="strong-black">развитие и</span></span><br> <span class="yelspan"><span class="strong-black">совершенствование</span></span>  навыков говорения, аудирования, чтения, письма, проработку лексики и грамматики.</p>
        </div>

        <div class="col-12 col-sm-5">
          <img src="~@/assets/hometeacher/images/programmki.png" alt="Групповые онлайн занятия по английскому языку" class="programmki desktop-vers">
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid bigwavetop desktop-vers"></div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid think">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8">
          <h2 class="iba desktop-vers"><span class="otkritost">Открытость и качество</span></h2>
          <h2 class="iba mobile-vers"><span class="otkritost1">Открытость</span><br> <span class="otkritost2">и качество</span></h2>
          <img src="~@/assets/hometeacher/images/think-img.png" alt="Групповые онлайн занятия по английскому языку" class="mobile-vers">
          <p class="leftp" style="max-width: 700px;">Родители имеют возможность <span class="strong-black">наблюдать за процессом обучения</span>. Онлайн-занятия проходят в <span class="strong-black">открытом для родителей формате</span>. </p>
          <p style="font-size: 10px;">&nbsp;</p>
          <div class="nomobik">
            <div class="chek"></div><p><span class="yelspan"><span class="strong-black">Задавайте любые вопросы педагогу</span></span> &ndash; на это отводится 5 минут в конце каждого урока. </p>
            <div class="chek"></div><p>Узнавайте новости, домашнее задание, делитесь мнением и пожеланиями о групповых занятиях  <span class="yelspan"><span class="strong-black">в родительском чате в Telegram.</span></span></p>
          </div>
          <div class="mobik">
            <div class="chek"></div><p><span class="yelspan"><span class="strong-black">Задавайте любые</span></span><br> <span class="yelspan"><span class="strong-black">вопросы педагогу</span></span> &ndash; на это отводится 5 минут в конце каждого урока. </p>
            <div class="chek"></div><p>Узнавайте новости, домашнее задание, делитесь мнением и пожеланиями о групповых занятиях <span class="strong-black">в родительском чате в Telegram</span>.</p>
          </div>

        </div>

        <div class="col-12 col-sm-4">
          <img src="~@/assets/hometeacher/images/think-img.png" alt="Групповые онлайн занятия по английскому языку" class="desktop-vers">
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid bigwavebottom desktop-vers"></div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid stars">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-7">
          <h2 class="iba desktop-vers"><span class="bezlimit">Безлимитный доступ</span><br> по выгодной цене</h2>
          <h2 class="iba mobile-vers"><span class="bezlimit1">Безлимитный</span><br> <span class="bezlimit2">доступ</span><br> по выгодной цене</h2>
          <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;">
            <img src="~@/assets/hometeacher/images/stars-img.jpg" alt="Групповые онлайн занятия по английскому языку">
          </div>
          <div class="chek"></div><p>При покупке абонемента на групповые занятия становятся  <span class="yelspan"><span class="strong-black">доступны все онлайн-уроки курса</span></span>,  указанные в расписании.</p>
          <p>Посещайте любые уроки в неограниченном количестве.</p>
          <div class="chek"></div><p>Абонемент также открывает  <span class="yelspan"><span class="strong-black">бесплатный доступ к</span></span><br> <span class="yelspan"><span class="strong-black">тестам-тренажерам</span></span>   к каждому уроку онлайн-занятий по программе.</p>
          <div class="chek"></div><p>Основной предмет изучения дополнен  <span class="yelspan"><span class="strong-black">вспомогательными</span></span><br> <span class="yelspan"><span class="strong-black">факультативными предметами</span></span> (в курсах аглийского это Story Time, Art Class, Music Class).</p>
          <div class="chek"></div><p>Покупая абонемент  <span class="yelspan"><span class="strong-black">на 3 и 6 месяцев, вы экономите 5% и 10%</span></span> от стоимости.</p>
        </div>

        <div class="col-12 col-sm-5">
          <img src="~@/assets/hometeacher/images/stars-img.png" alt="Групповые онлайн занятия по английскому языку" class="desktop-vers">
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid greentop"></div>
  <div class="container-fluid greenfon">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-7">
        <h2>С “Полиглотиками”<br> учить иностранный язык — <br>
        <span class="veselo">весело и интересно!</span></h2>
        </div>

        <div class="col-12 col-sm-5">
          <img src="~@/assets/hometeacher/images/strlka.png">
          <div class="knpk-yellow"><a href="https://poliglotiki.com/home-teacher/schedule">Попробовать бесплатно</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid greendown"></div>

  <div class="container-fluid produman">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6">
          <h2 class="iba desktop-vers"><span class="produm">Продумано</span> до мелочей</h2>
          <h2 class="iba mobile-vers"><span class="produm">Продумано</span><br> до мелочей</h2>
          <img src="~@/assets/hometeacher/images/produman-mob.jpg" class="mobile-vers">
          <p class="leftp">Образовательная онлайн-платформа <span class="strong-black">OnlineTeacher</span>:</p>
          <div class="chek"></div><p><span class="strong-black">Бесперебойная связь</span>, высокое качество изображения и звука</p>
          <div class="chek"></div><p><span class="strong-black">Информативный</span> личный кабинет родителя</p>
          <div class="chek"></div><p><span class="strong-black">Система оповещений, поддержка:</span> по email, в чате сайта и в Telegram-канале для родителей</p>
          <div class="chek"></div><p>Подробное расписание с <span class="strong-black">разнообразным выбором</span> групповых занятий и повторами уроков</p>
          <div class="chek"></div><p><span class="strong-black">Консультации педагогов</span> для родителей.</p>

          <p class="leftp exkl">Мы продумали каждую мелочь, чтобы ребенку было  <span class="yelspan"><span class="strong-black">комфортно заниматься и развиваться.</span></span></p>
        </div>

        <div class="col-12 col-sm-6">
          <img src="~@/assets/hometeacher/images/produman.jpg" class="desktop-vers">
        </div>
      </div>

    </div>
  </div>
  <div class="container-fluid bigwavetop desktop-vers"></div>
  <div class="container-fluid liniya mobile-vers"></div>
  <div class="container-fluid white-bg fr-page no-shadow kak-pr">
    <div class="container align-middle">
      <div class="row">
        <div class="col-12">
          <h2 class="iba"><span class="kak">Как проходят</span> онлайн-занятия</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <carousel :responsive="{0:{items:1},1000:{items:2}}">
            <div class="centers-text mx-3">
              <a href="/images/gall-1.jpg" target="_blank"><img src="@/assets/hometeacher/images/gall-1.jpg" class="zanat"></a>
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-2.jpg" class="zanat">
            </div>

            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-3.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-4.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-5.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-6.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-7.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-8.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-9.jpg" class="zanat">
            </div>
            <div class="centers-text mx-3">
              <img src="@/assets/hometeacher/images/gall-10.jpg" class="zanat">
            </div>
          </carousel>
        </div>
      </div>

      <div class="row kakimg">
        <div class="col-12 col-sm-6">
          <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                  src="https://www.poliglotiki.ru/embed/KnlzTavUb38" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
        <div class="col-12 col-sm-6">
          <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                  src="https://www.poliglotiki.ru/embed/RUu5Y6MkosI" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
      <div class="row kakimg">
        <div class="col-12 col-sm-6">
          <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                  src="https://www.poliglotiki.ru/embed/grdB0RPsaOs" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
        <div class="col-12 col-sm-6">
          <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                  src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid yellow-presents">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-7">
          <h2 class="iba desktop-vers">3 дня занятий <span class="znt">в подарок</span></h2>
          <h2 class="iba mobile-vers">3 дня занятий<br> <span class="znt">в подарок</span></h2>
          <img src="~@/assets/hometeacher/images/present-bird.png" class="mobile-vers">
          <p class="exkl leftp"><span class="strong-black znt1">Запишитесь на бесплатные пробные занятия</span><br>
          <span class="strong-black znt2">с безлимитным доступом в первые 3 дня.</span></p>

          <p class="px20">Педагог вовлекает ребят в процесс с первой минуты занятия, и <span class="strong-black">ребенок сможет проявить активность</span> на пробных занятиях. </p>

          <p class="px20">А родитель <span class="strong-black">убедится в эффективности</span> программы и методики.</p>
          <img src="~@/assets/hometeacher/images/strlka-r.png" class="strlka-r desktop-vers">
          <div class="knpk-down"><a href="https://poliglotiki.com/home-teacher/schedule">Записаться</a></div>
        </div>

        <div class="col-12 col-sm-5">
          <img src="~@/assets/hometeacher/images/present-bird.png" class="desktop-vers">
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 70px;">
    <div class="container align-middle">
      <div class="row">
        <div class="col-12">
          <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
          <p>&nbsp;</p>
        </div>
      </div>
      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">24.05.2021</span>
          <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

          <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

        </div>
      </div>
      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">21.05.2021</span>
          <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857" target="_blank">vk.com</a></span><br>

          <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

        </div>
      </div>

      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/no-avatar-1.png"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">20.05.2021</span>
          <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

          <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

        </div>
      </div>
      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                             src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">18.05.2021</span>
          <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517" target="_blank">facebook.com</a></span><br>

          <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

        </div>
      </div>
      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                             src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">27.02.2021</span>
          <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                       rel="nofollow">vk.com</a></span><br>

          <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
        </div>
      </div>

      <div class="row mention justify-content-center">
        <div class="col-12 col-sm-2 m-photo">
          <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                             src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
        </div>
        <div class="col-12 col-sm-10 home-mention">
          <span class="dateotzyv">22.01.2021</span>
          <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                     rel="nofollow">vk.com</a></span><br>

          <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  components: {
    carousel
  },
  name: "AnglijskijOnlajnVGruppe",

  data: function () {
    return {
      title: null,
    }
  },

  metaInfo() {
    return {
      title: 'Групповые онлайн занятия по английскому языку',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Обучение детей от 12 месяцев до 12 лет в группе онлайн через игру и увлекательные задания с полным погружением в изучаемую языковую среду.'
        }
      ]
    }
  },
}
</script>

<style scoped>

.yellow-letter {
  background: url(~@/assets/hometeacher/images/bg-yellow-letters-2.jpg) repeat-y center top;
  /*min-height: 650px;*/
  margin-top: 0px;
  padding-bottom: 20px;
  box-shadow: inset 0 3px 5px #00000038;
}
.yellow-wave{background: url(~@/assets/hometeacher/images/bg-yellow-letters-down.png) no-repeat center;
  width:100%;
  height: 149px;
  margin-top: -2px;}
.breadcrumbs {font-size: 14px;background: #fff;
  max-width: 510px;
  padding-left: 5px;
  border-radius: 10px;}

.yellow-letter h1 {
  font-size: 50px;
  font-family: Manrope Black;
  margin-top: 15px;
  margin-bottom: 0px;
  color:#000;
}
.yellow-letter h3 {
  font-size: 30px;
  font-family: Manrope Bold Alt;
  color:#000;
  margin-bottom: 40px;
}
.yell-green{background-image: url(~@/assets/hometeacher/images/yell-green.png);
  padding-left: 8px; padding-bottom: 8px;
  padding-right: 8px;}

.yellow-letter p {font-size: 20px;    max-width: 670px;    line-height: 1.4;}

.childs{
  float: right;
  margin-right: -100px;
  margin-left: -38px;
  margin-top: -50px;
}
.knpk{
  border-radius: 35px;
  max-width: 350px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear,left bottom,left top,from(#39ab22),to(#49da2c));
  font-size: 22px;
  color: #fff;
  padding: 15px 30px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
  max-width: 350px;
  margin-top: 60px;
}
.knpk:hover {background: #39ab22;}
.knpk-down:hover {background: #39ab22;}
.knpk a, .knpk-down a {color:#fff;}
.pdtop50px {padding-top: 50px;}
.iba{font-family: Manrope Bold Alt;
    font-size: 40px; color:#000; margin-bottom: 40px;
}
.mrgtopbtn {margin-bottom: 20px; margin-top: 20px;}
.small-clouds {
  background: url(~@/assets/hometeacher/images/small-clouds.png) no-repeat center top;
  margin-top: 0px;
  min-height: 650px;
  margin-bottom: 40px;
  box-shadow: inset 0 3px 5px #00000038;
}
.small-clouds p, .small-strelki p, .listochki p, .think p, .stars p, .produman p, .par p {font-size: 20px;    margin-left: 35px;}
.yegr {background-image: url(~@/assets/hometeacher/images/yegr.png);
  padding-left: 8px; padding-bottom: 2px;
  padding-right: 8px;}
.px20{font-size: 20px; margin-top: 40px !important;}
.chek {background: url(~@/assets/hometeacher/images/chek.png) no-repeat top left;
  font-size: 20px; float: left; width:25px; height: 20px;margin-top: 8px;
}
.chek p {font-size: 20px;}
.twokinds{margin-top: 50px;}
.birdskids {margin-left: -50px; margin-top: -50px;}
/*.mgtop130 {margin-top: 130px;}*/

.gryelgrn{background-image: url(~@/assets/hometeacher/images/gryelgrn.png);
  padding-left: 8px; padding-bottom: 10px;
  padding-right: 8px;}
.leftp{margin-left: 0px !important;}
.yelspan{
  background: #f6eeb0;
  padding: 3px 10px;
  border-radius: 17px;
  color: #000;
}
.pdlft80px {padding-left: 80px;}
.small-strelki {
  background: url(~@/assets/hometeacher/images/small-strelki.png) no-repeat center top;
  min-height: 650px;
  margin-top: 0px;
  padding-bottom: 40px;
  box-shadow: inset 0 3px 5px #00000038;
}
.igraya{background-image: url(~@/assets/hometeacher/images/igraya.png);
  padding-left: 8px; padding-bottom: 10px;
  padding-right: 8px;}
.dostavka{background-image: url(~@/assets/hometeacher/images/dostavka.png);
  padding-left: 8px; padding-bottom: 10px;    padding-top: 2px;
  padding-right: 8px;}

.shag{background-image: url(~@/assets/hometeacher/images/shag.png);
  font-size: 25px;
  padding-left: 8px; padding-bottom: 10px;
  padding-right: 8px;
  max-width: 1038px;
  padding-top: 15px;
  padding-left: 18px;
  margin-top: 50px;}
.bigwavetop {
  background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
  width:100%;
  height: 190px;
  margin-top: -50px;
}
.bigwavebottom {
  background: url(~@/assets/hometeacher/images/bigwavebottom.png) no-repeat center;
  width:100%;
  height: 186px;
  margin-top: -80px;
}
.listochki {
  background: url(~@/assets/hometeacher/images/listochki.png) no-repeat center;
  width:100%;
  min-height: 851px;
  margin-top: -25px;
  padding-top: 130px;
}
.listochki h2 {max-width: 450px;}
.raketa {float: right; margin-top: -50px;}
.fon-krugi {
  background: url(~@/assets/hometeacher/images/fon-krugi.png) no-repeat center;
  width:100%;
  min-height: 744px;
  margin-top: -25px;
  padding-top: 130px;
}
.programmki{margin-top: -110px;}
.uvlek{background-image: url(~@/assets/hometeacher/images/uvlek.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;}
.razvsov{font-size: 25px; margin-top: 40px; margin-right: -100px;}

.think {
  background: url(~@/assets/hometeacher/images/think.png) no-repeat center;
  width:100%;
  min-height: 661px;
  margin-top: -25px;
  padding-top: 130px;
}
.stars {
  background: url(~@/assets/hometeacher/images/starss.png) no-repeat center;
  width:100%;
  min-height: 1060px;
  margin-top: -100px;
  padding-top: 230px;
}
.otkritost{background-image: url(~@/assets/hometeacher/images/otkritost.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;}
.bezlimit{background-image: url(~@/assets/hometeacher/images/bezlimit.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;}

.greentop {
  background: url(~@/assets/hometeacher/images/greentop.jpg) no-repeat center;
  width:100%;
  height: 56px;
}
.greendown {
  background: url(~@/assets/hometeacher/images/greendown.jpg) no-repeat center;
  width:100%;
  height: 61px;
}
.greenfon {
  background: url(~@/assets/hometeacher/images/greenfon.png) repeat-y center;
  min-height: 290px;
  overflow: hidden;
}
.greenfon img{
  float: right;
  margin-right: -401px;
  margin-top: 107px;
  height: 33px;
  max-width: 100%;
}
.greenfon h2 {
  font-family: Manrope Bold Alt;
  font-size: 40px;
  color: #fff;
  margin-top: 50px;
  line-height: 1.3;
}
.veselo {background-image: url(~@/assets/hometeacher/images/veselo.png);
  padding-left: 8px; padding-top: 2px; color:#000; padding-bottom: 8px;
  padding-right: 8px;}

.knpk-yellow {
  border-radius: 35px;
  max-width: 365px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear,left bottom,left top,from(#ffce00),to(#fbfe00));
  font-size: 24px;
  padding: 15px 30px;
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
  margin-top: 90px;
}
.knpk-yellow:hover{background: #fbfe00;}
.knpk-yellow a {color:#000;}

.produm {background-image: url(~@/assets/hometeacher/images/produm.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;    padding-bottom: 7px;}
.produman {padding-bottom: 40px;     padding-top: 70px;}
.produman h2 {/*
  font-family: Manrope Bold Alt;
  font-size: 40px;     color: #000;
  margin-top: 70px; margin-bottom: 40px;*/
}
.kak {background-image: url(~@/assets/hometeacher/images/kak.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;    padding-bottom: 7px;}
.kak-pr h2{margin-top: 80px !important; margin-bottom: 70px !important;}
.kakimg img {border-radius: 20px; margin-bottom: 40px;
  box-shadow: 7px 7px 12px rgb(0 0 0 / 20%);}

.yellow-presents {
  background: url(~@/assets/hometeacher/images/yellow-presents.jpg) no-repeat center top;
  min-height: 827px;
  margin-top: 10px;
  padding-bottom: 40px;
  padding-top: 230px;
  overflow: hidden;
}
.znt {background-image: url(~@/assets/hometeacher/images/znt.png);
  padding-left: 8px; padding-top: 2px;
  padding-right: 8px;    padding-bottom: 7px;}
.znt1 {background-image: url(~@/assets/hometeacher/images/znt1.png);
  padding-left: 8px; padding-top: 3px;
  padding-right: 3px;   padding-bottom: 11px;}

.znt2 {background-image: url(~@/assets/hometeacher/images/znt2.png);
  padding-left: 8px; padding-top: 3px;
  padding-right: 6px;   padding-bottom: 11px;}

.exkl{font-size: 25px;
  margin-right: -15px;
  margin-top: 40px;}
.yellow-presents img {margin-top: 50px; margin-left: 30px;}

.knpk-down{
  border-radius: 35px;
  max-width: 220px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear,left bottom,left top,from(#39ab22),to(#49da2c));
  font-size: 22px;
  color: #fff;
  padding: 15px 40px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
  margin-top: 60px;
}
.strlka-r {float: left;    margin-left: -480px !important;
  margin-top: 60px !important;}

.liniya {background-image: url(~@/assets/hometeacher/images/liniya.png); width:100%; height:36px;}
.yellfon{font-size: 20px; background: #f6eeb0; padding: 30px 15px;     color: #000;
  margin-right: -15px; margin-left: -15px; margin-top: 20px; margin-bottom: 20px;}
.clock {float: right; margin-top: 30px; margin-right: -16px;}
.mobik {display: none;}
.nomobik {display: block;}

.vidos {
  width:100%;
  height: 100%;
  border-radius: 15px;
  margin-right: 0px !important;
  margin-bottom: 100px !important;
}
.kakimg {margin-bottom: 20px;}

.zanat {/*width:300px;*/ max-height: 235px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  border: 12px solid #e6eff2;
  border-radius: 10px;}

@media (max-width: 1366px) {
  .think img, .stars img {max-width: 100%;}
}
@media (max-width: 1280px) {
  .childs, .programmki {max-width: 100%;}
  .twokinds, .kakimg img, .produman img {max-width: 100%;}
  .birdskids{max-width: 100%; margin-left: 0px;}
  .childs {margin-right: -60px;}
}
@media (max-width: 1152px) {
  .childs {margin-right: -90px;}
  .zanat {max-height: 200px;}
  .knpk {margin-top: 20px;}
}
@media (max-width: 1024px) {
  .childs {margin-right: -30px; margin-top: -30px; max-width: 350px; }
  .raketa {margin-right: -70px;}
}
@media (max-width: 800px) {
  .yellow-presents{background: #f9f2bc url(/home-teacher/img/yellow-presents.jpg) no-repeat center top; }
  .knpk-yellow {text-align: center;}
  .greenfon h2 {font-size: 35px;}
}

@media (max-width: 575px) {
  .yellow-letter, .small-clouds, .par, .small-strelki, .listochki, .fon-krugi, .think, .stars, .greenfon, .produman, .kak-pr, .yellow-presents {padding-left: 15px !important; padding-right: 15px !important;}
  .yellow-letter h1 {font-size: 45px;    line-height: 40px; margin-top: 35px;}
  .yell-green {font-size: 30px; background-image: url(~@/assets/hometeacher/images/yell-green-mob.png); padding-top: 2px;
    padding-bottom: 10px;}
  .breadcrumbs {margin-left: 0px; margin-top: 30px;}
  .childs {float: none; max-width: 100%; margin: 0px;    margin-top: 20px;}
  .small-clouds, .small-strelki, .listochki, .fon-krugi, .think, .stars {background: none;}
  .small-strelki {    padding-bottom: 0px;}
  .fon-krugi, .think {padding-top: 15px;    padding-bottom: 50px}
  .listochki {padding-top: 10px; padding-bottom: 50px;}
  .twokinds, .birdskids, .raketa {max-width: 70%; margin-top: 0px;  float: none;  margin-bottom: 20px;}
  .pdtop50px {padding-top: 0px;}
  .iba {font-size: 33px;    line-height: 42px;    margin-bottom: 20px; margin-top: 10px;}
  .yegr {background-image: url(~@/assets/hometeacher/images/yegr-mob.png);    padding-top: 3px;}
  .pdlft80px {padding-left: 15px;}
  .gryelgrn{background-image: url(~@/assets/hometeacher/images/gryelgrn-mob.png);    padding-top: 3px;}
  .igraya{background-image: url(~@/assets/hometeacher/images/igraya-mob.png);     padding-bottom: 5px;}
  .shag{background-image: none; font-size: 20px; padding: 30px 15px;
    background: -webkit-gradient(linear,left bottom,right top,from(#e0fe82),to(#fdfa97));
    margin-right: -15px; margin-left: -15px;  margin-top: 40px;}
  .dostavka{background-image: url(~@/assets/hometeacher/images/dostavka-mob.png);}
  .uvlek{background-image: url(~@/assets/hometeacher/images/uvlek-mob.png);}
  .programmki {margin-top: 0px;}
  .razvsov {margin-right: 0px;}
  .think img {margin-top: 30px; margin-bottom: 40px;}
  .stars {margin-top: 0px; padding-top: 0px;    padding-bottom: 50px;}
  .otkritost1 {background: url(~@/assets/hometeacher/images/otkritost-mob-1.png) no-repeat center top; padding-left: 7px;
    padding-right: 8px; padding-top: 3px;}
  .otkritost2 {background: url(~@/assets/hometeacher/images/otkritost-mob-2.png) no-repeat center top;padding-left: 7px;
    padding-right: 8px; padding-top: 3px;}
  .bezlimit1 {background: url(~@/assets/hometeacher/images/bezlimit1.png) no-repeat center top; padding-left: 7px;
    padding-right: 8px; padding-top: 3px;}
  .bezlimit2 {background: url(~@/assets/hometeacher/images/bezlimit2.png) no-repeat center top;padding-left: 7px;
    padding-right: 8px;  padding-bottom: 10px;}
  .stars img {margin-bottom: 30px;}
  .greenfon h2 {font-size: 25px;}
  .greenfon img {display: none;}
  .veselo{background-image: url(~@/assets/hometeacher/images/veselo-mob.png);    padding-bottom: 10px;}
  .knpk-yellow{font-size: 20px; padding: 20px 10px; max-width: 100%; margin-top: 40px;    margin-bottom: 50px;}
  .produm{background-image: url(~@/assets/hometeacher/images/produm-mob.png);    padding-bottom: 10px;}
  .kak-pr h2 {margin-top: 5px !important; margin-bottom: 35px !important;}
  .kak {background-image: url(~@/assets/hometeacher/images/kak-mob.png);    padding-bottom: 10px;}
  .yellow-presents{
    background-image: url(~@/assets/hometeacher/images/bg-yellow-letters-2.jpg);
    padding-top: 60px;}
  .yellow-presents img {margin-top: -147px; float: right; width: 100px;}
  .znt {background-image: url(~@/assets/hometeacher/images/znt-mob.png);    padding-bottom: 10px;}
  .knpk-down{ font-size: 22px; padding: 20px 10px; max-width: 100%;
    margin-top: 40px;  margin-bottom: 50px; text-align: center;}
}


@media (max-width: 450px) {
  .mobik {display: block;}
  .nomobik {display: none;}
  .zanat {max-height: 170px;}
}
@media (max-width: 390px) {
  .listochki h2 {max-width: 245px;}
  .zanat {max-height: 145px;}
}
</style>
